import React from 'react';
import { Helmet } from 'react-helmet-async';

const ContactUs = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us - Dental Stores</title>
        <meta
          name="description"
          content="Get in touch with Dental Stores. Find our address, phone number, and email for inquiries and support."
        />
      </Helmet>
      <div style={{ padding: '48px 24px 96px', maxWidth: '960px', margin: '0 auto', color: '#1f2933' }}>
        <header style={{ marginBottom: '48px' }}>
          <p
            style={{
              margin: 0,
              color: '#1565C0',
              fontWeight: '600',
              letterSpacing: '0.32em',
              textTransform: 'uppercase',
              fontSize: '12px',
            }}
          >
            We're here to help
          </p>
          <h1
            style={{
              fontSize: '38px',
              fontWeight: '700',
              margin: '12px 0 0',
              lineHeight: 1.25,
              color: '#102a43',
            }}
          >
            Contact Dental Stores
          </h1>
          <p style={{ marginTop: '18px', fontSize: '17px', lineHeight: 1.7, maxWidth: '720px', color: '#52606d' }}>
            Questions, orders, product guidance—our specialists are just a message away. Reach out however it suits you
            best.
          </p>
        </header>

        <section style={{ display: 'grid', gap: '32px' }}>
          <article
            style={{
              backgroundColor: '#f8fafc',
              border: '1px solid #d9e2ec',
              borderRadius: '16px',
              padding: '28px',
              display: 'grid',
              gap: '18px',
            }}
          >
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>Visit or Call</h2>
            <div style={{ display: 'grid', gap: '12px', fontSize: '16px', color: '#52606d' }}>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2933' }}>Address</h3>
                <p style={{ margin: '6px 0 0' }}>
                  DentalStores.in
                  <br />
                  A unit of THDD
                  <br />
                  2nd floor, 4-1-1229,
                  <br />
                  King Kothi Road,
                  <br />
                  Hyderabad - 500001, TS
                </p>
              </div>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2933' }}>Phone</h3>
                <p style={{ margin: '6px 0 0' }}>
                  +91 70931 34343
                </p>
              </div>
            </div>
          </article>

          <article
            style={{ border: '1px solid #d9e2ec', borderRadius: '16px', padding: '28px', display: 'grid', gap: '16px' }}
          >
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>Write to Us</h2>
            <div style={{ display: 'grid', gap: '10px', fontSize: '16px', color: '#52606d' }}>
              <span>
                <strong style={{ color: '#1f2933' }}>General:</strong> info@dentalstores.in
              </span>
            </div>
          </article>

          <article
            style={{ border: '1px solid #d9e2ec', borderRadius: '16px', padding: '28px', display: 'grid', gap: '12px' }}
          >
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>Business Hours</h2>
            <p style={{ margin: 0, fontSize: '17px', lineHeight: 1.7, color: '#52606d' }}>
              Monday – Saturday: 10:30 AM – 7:00 PM IST
              <br />
              Sunday: Closed
              <br />
              Emergency support available around the clock.
            </p>
            <p style={{ margin: 0, fontSize: '16px', color: '#52606d' }}>
              Visiting the office? Schedule an appointment so we can prepare the right specialist for you.
            </p>
          </article>

          <article style={{ display: 'grid', gap: '12px' }}>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#102a43' }}>Follow Us</h2>
            <p style={{ margin: 0, fontSize: '16px', color: '#52606d' }}>
              Get product launches, dental care tips, and behind-the-scenes updates delivered to your feed.
            </p>
            <ul
              style={{
                margin: 0,
                paddingLeft: '20px',
                display: 'grid',
                gap: '8px',
                fontSize: '16px',
                color: '#1f2933',
              }}
            >
              <li>Facebook: @DentalStoresIndia</li>
              <li>Instagram: @dentalstores_in</li>
              <li>Twitter: @DentalStoresIN</li>
              <li>LinkedIn: Dental Stores India</li>
            </ul>
          </article>
        </section>
      </div>
    </>
  );
};

export default ContactUs;
